module.exports = __webpack_public_path__ + "img/bike-black.4d3c9766.svg";